var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24.401,
    viewBox: "0 0 30 24.401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M701.268,398.384h-22.4a3.807,3.807,0,0,1-3.8-3.8v-16.8a3.805,3.805,0,0,1,3.8-3.8h22.4a3.8,3.8,0,0,1,3.8,3.8v16.8A3.8,3.8,0,0,1,701.268,398.384Zm-22.4-22.4a1.8,1.8,0,0,0-1.8,1.8v16.8a1.8,1.8,0,0,0,1.8,1.8h22.4a1.8,1.8,0,0,0,1.8-1.8v-16.8a1.8,1.8,0,0,0-1.8-1.8Z",
    transform: "translate(-675.067 -373.983)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M690.066,387.182a1,1,0,0,1-.572-.18l-14-9.8a1,1,0,0,1,1.146-1.638l13.426,9.4,13.425-9.4a1,1,0,1,1,1.148,1.638l-14,9.8A1,1,0,0,1,690.066,387.182Z",
    transform: "translate(-675.067 -372.583)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d61c04bf13926ab22f1104de486b1398.svg";
export { ForwardRef as ReactComponent };